import CustomLeafletControl from 'components/BaseMap/components/CustomLeafletControl';
import BaseTooltip from 'components/Tooltips/BaseTooltip';
import PlacesAutocompleteInput from 'features/Responder/features/Tours/features/TourBuilder/components/PlacesAutocompleteInput';
import React, { useMemo, useState } from 'react';
import { useMap } from 'react-leaflet';

/**
 * Leaflet control that exposes Google Places autocomplete and pans the map
 * to the selected result.
 */
export default function GoogleLocationSearchControl({ googleApiKey, minZoom = 14 }) {
  const map = useMap();
  const [query, setQuery] = useState('');
  const inputState = useMemo(() => ({ address: query }), [query]);
  const hasQuery = `${query}`.trim().length > 0;

  const handleManualChange = (value) => {
    setQuery(value);
  };

  const handlePlaceSelect = (location) => {
    const lat = Number(location?.lat);
    const lng = Number(location?.lng);
    const address = `${location?.address || ''}`.trim();
    if (address) setQuery(address);
    if (!map || !Number.isFinite(lat) || !Number.isFinite(lng)) return;
    const currentZoom = Number(map.getZoom?.());
    const targetZoom = Number.isFinite(currentZoom) ? Math.max(currentZoom, minZoom) : minZoom;
    map.setView([lat, lng], targetZoom, { animate: true });
  };

  const handleClearSearch = () => {
    setQuery('');
  };

  return (
    <CustomLeafletControl position="topcenter">
      <div
        className="responder-google-search-control leaflet-bar"
        onMouseDown={(event) => event.stopPropagation()}
        onDoubleClick={(event) => event.stopPropagation()}
      >
        <div className="responder-google-search-control__row">
          <div className="responder-google-search-control__input">
            <PlacesAutocompleteInput
              stop={inputState}
              onPlaceSelect={handlePlaceSelect}
              onManualChange={handleManualChange}
              placeholder="Search Google location..."
              apiKey={googleApiKey}
            />
          </div>
          <BaseTooltip id="responder-map-clear-search" text="Clear search">
            <button
              type="button"
              className="responder-google-search-control__clear btn btn-sm btn-outline-secondary"
              onMouseDown={(event) => event.stopPropagation()}
              onClick={handleClearSearch}
              aria-label="Clear search"
              disabled={!hasQuery}
            >
              &times;
            </button>
          </BaseTooltip>
        </div>
      </div>
    </CustomLeafletControl>
  );
}
